<template>
 <div class="countBox">
    <i class="iconfont add" :class="{disable: min>=value}"  @click="changeNum('minus')">&#xe691;</i>
        <span class="num">{{value}}</span>
    <i class="iconfont minus" :class="{disable:(max&&max!==0)&&max<=value}" @click="changeNum('plus')">&#xe666;</i>
 </div>
</template>
<script>
export default {
  name: "form-item",
  props: {
    value:{
        type:[Number,String],
        default:1
    },
    min:{
        default:1
    },
    max:{
        default:'',
    }
  },
  data() {
    return {

    };
  },
  methods: {
    changeNum(t){
        let value=this.value;
        if(typeof value=='string'){
            value=Number(value)
        }
        
        if(t=='minus'){
            if(value>this.min){
                value--
            }
        }else if(t=='plus'){
            if(this.max||this.max===0){
                if(value<this.max){
                    value++
                }
            }else{
                value++
            }
        }
        // 外部更改值
        if(this.value!=value){
            this.$emit('change',value)
        }
        
    }
  }
};
</script>
<style lang="scss" scoped>
    .countBox{
        display: inline-block;
        .add{
            width: 16px;
            height: 16px;
            font-size: 16px;
             cursor: pointer;
        }
        .num{
            font-size: 16px;
            margin-left:16px ;
            margin-right: 16px;
            
        }
        .minus{
             cursor: pointer;
            width: 16px;
            height: 16px;
            font-size: 16px;
        }
        .disable{
            background: #f6f6f6;
            color: #666;
            border-radius: 50%;
            cursor: not-allowed ;
        }
    }
</style>
